import { FC, ReactNode } from 'react'

import { AdsSafeContext, GeoPreviewContext } from './adsSafe'

/**
 * A GEO page at its final URL, promoted from its validation copy (/<page>-v2, PRD section 12; the last copies went
 * live on 28/10/2026 and the -v2 URLs answer a 301, next.config.js): the shared sections keep the version Morgan
 * validated (GeoPreviewContext) and, on pages that receive ads, the Ads vocabulary of PRD section 4
 * (AdsSafeContext). The page file keeps its own GTM page event, the same as before the promotion. A future
 * validation copy: its own page file with `noindex` in GeoHead, an X-Robots-Tag header and a router alias to the
 * final path (GeoPreview/PathnameAlias in the git history before 28/10/2026).
 */
const GeoPage: FC<{ adsSafe?: boolean; children: ReactNode }> = ({ adsSafe = true, children }) => (
  <GeoPreviewContext.Provider value>
    <AdsSafeContext.Provider value={adsSafe}>{children}</AdsSafeContext.Provider>
  </GeoPreviewContext.Provider>
)

export default GeoPage
